import React, { useCallback } from 'react';
import { useAtom } from 'jotai';
import { PlayerZoom } from '../../../../common/player-controls';
import { timelineZoomAtom } from '../../atoms/frame-timeline-v4';
import { BUTTON_SIZE, ZOOM_MAX, ZOOM_MIN } from './constants';
export const TimelineZoom = () => {
  const [zoom, setZoom] = useAtom(timelineZoomAtom);
  const handleZoomChange = useCallback((value: number) => {
    setZoom(value);
  }, [setZoom]);
  return <PlayerZoom zoom={zoom} min={ZOOM_MIN} max={ZOOM_MAX} onZoomChange={handleZoomChange} iconSize={BUTTON_SIZE} tooltipContent={`Zoom: ${zoom}%`} />;
};